<template>
  <el-dialog
    width="480px"
    :close-on-click-modal="false"
    :visible.sync="show"
    class="batsupplier--dialog"
    :title="$t('stores::products-info::edit_supplier_title')"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item prop="supplier" :label="$t('system::responsible::供应商')">
        <el-select v-model="form.supplier" clearable style="width: 75%">
          <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <span class="batsupplier--plus" @click="addNewModal = true">+</span>
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center">
      <el-button style="width: 72px" @click="show = false" size="small">
        {{ $t('system::common::btn::cancel') }}
      </el-button>
      <el-button style="width: 72px" type="primary" size="small" @click="setConfirm">
        {{ $t('system::common::btn::save') }}
      </el-button>
    </div>
    <edit-dialog :isNew="true" v-model="addNewModal" :appendToBody="true" @getListData="handleAdd"></edit-dialog>
  </el-dialog>
</template>

<script>
import { setSupplier, getSupplierList } from '@/server/product'
import editDialog from '@/views/supplier/components/editDialog'

export default {
  name: 'BatchSetSupplier',
  components: {
    editDialog,
  },
  props: {
    supplierList: {
      type: Array,
    },
    selection: {
      type: Array,
    },
  },
  data() {
    return {
      addNewModal: false,
      list: [],
      form: {
        supplier: '',
      },
      rules: {
        supplier: [{ required: true, message: $t('storage::in-stock::supplier_select_holder'), trigger: 'blur' }],
      },
      show: false,
    }
  },
  watch: {
    supplierList: {
      handler(val) {
        this.list = val
      },
    },
  },
  methods: {
    showDialog() {
      this.form.supplier = ''
      this.show = true
    },
    setConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const spuIds = this.selection.map(item => item.spuId)
          const { data } = await setSupplier({
            spuIds,
            supplierId: this.form.supplier,
          })
          if (data.code === this.$code) {
            this.$message.success($t('system::tip::control_success'))
            this.$emit('success')
            this.show = false
          }
        }
      })
    },
    async handleAdd() {
      // 查询供应商
      const { data } = await getSupplierList({
        page_num: 1,
        status: 1,
        page_size: 100,
      })
      this.list = data.data.items.map(item => {
        return {
          label: item.name,
          value: item.id,
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.batsupplier--plus {
  display: inline-block;
  width: 30px;
  height: 30px;
  background: #f0f0f0;
  border-radius: 4px;
  color: #0560fd;
  vertical-align: middle;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  font-size: 23px;
  margin-left: 16px;
  cursor: pointer;
}
.batsupplier--dialog {
  /deep/ .el-dialog__body {
    padding: 40px 16px 8px 16px;
  }
}
</style>
